import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { api } from 'constants/api';

import { ApiError, ApiResponse } from 'types/utils/api-response';
import { QueryOptions } from 'types/utils/query-options';

export type RoleCode =
  | 'developer_vendor'
  | 'franchise_owner'
  | 'admin'
  | 'moderator'
  | 'agent';

export type RoleType = {
  name: string;
  description: string;
  code: RoleCode;
  id: number;
};

export type RolesResponseType = RoleType[];

export const useGetRoles = (
  options: QueryOptions<RolesResponseType, AxiosError<ApiError>> = {}
) =>
  useQuery({
    queryFn: async (): Promise<RolesResponseType> => {
      const { data } =
        await api.get<ApiResponse<RolesResponseType>>(`/user/role/list`);

      return data.data;
    },
    queryKey: ['roles'],
    ...options,
  });
